import $ from 'jquery'

if (document.getElementById('page-about')) {
  // #page-topがあるページだけで実行
  page()
}

function page() {
  $(window).on('scroll', () => {
    const point = $(window).scrollTop() + $(window).height() * 0.5
    $('.js-invert').each(function () {
      const $self = $(this)
      if ($self.offset().top <= point) {
        $self.addClass('is-invert')
      } else {
        $self.removeClass('is-invert')
      }
    })

    if ($('.js-switch').offset().top + $('.js-switch').outerHeight() * 0.5 < point) {
      $('.js-switch').addClass('is-switch')
    } else {
      $('.js-switch').removeClass('is-switch')
    }
  })

  $('.aboutQuality__list').on('click', function () {
    const $target = $(this)
    $target.stop(true, true)
    $target.toggleClass('is-open')
  })
}
